// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__CT13J","title":"ClientReferral_title__3EOQg","itemText":"ClientReferral_itemText__1Wjio"};